import React from "react";
import { Camera } from "lucide-react";

// Marks any stat or tool whose data is powered by the NicheCom content feed.
export function NicheComTag({ className = "" }) {
  return (
    <span
      data-testid="nichecom-tag"
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${className}`}
      style={{ background: "var(--grad-green-soft)", color: "#5F8213" }}
    >
      <Camera size={10} strokeWidth={2.25} /> NicheCom
    </span>
  );
}

export default NicheComTag;
